import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import store from "@/store";

const helperExcel = {
  async excelImport(file, rowsToIgnore) {
    const types = file.name.split(".").pop().toLowerCase();
    const fileType = ["xlsx", "csv"].includes(types);

    if (!fileType)
      throw "¡Error de formato! Vuelva a seleccionar";

    const workbook = new ExcelJS.Workbook();
    const buffer = await file.arrayBuffer();
    await workbook.xlsx.load(buffer);

    const result = [];

    workbook.eachSheet((sheet) => {
      const data = [];
      let headers = [];

      sheet.eachRow((row, rowIndex) => {
        const values = row.values.slice(1); // Ignorar índice 0
        if (rowIndex === rowsToIgnore + 1) {
          headers = values.map(h => //aca convertimos a mayusculas todo
            h?.toString().trim().toUpperCase() ?? ""
          );
        } else if (rowIndex > rowsToIgnore + 1) {
          const rowObj = {};
          values.forEach((cell, i) => {
            rowObj[headers[i]] = cell;
          });
          data.push(rowObj);
        }
      });

      result.push({
        hoja: sheet.name,
        filas: data,
      });
    });

    return result;
  },

  async excelExport(jsonArray, fileName, options = {}) {
    if (!Array.isArray(jsonArray.filas) || jsonArray.filas.length === 0) {
      console.error(
        "Los datos proporcionados para la exportación están vacíos o no son válidos."
      );
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(jsonArray.hoja);

    const headers = Object.keys(jsonArray.filas[0]);
    worksheet.columns = headers.map((header) => ({
      header: header,
      key: header,
      width: header.length, 
    }));

    jsonArray.filas.forEach((row) => {
      worksheet.addRow(row);
    });

    // Configuración por defecto
    const defaultOptions = {
      maxColumnWidth: 80,
      columnWidths: {},
      autoFitColumns: true
    };
    
    const config = { ...defaultOptions, ...options };

    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      
      if (config.autoFitColumns) {
        column.eachCell({ includeEmpty: true }, (cell) => {
          const cellValue = cell.value ? cell.value.toString() : "";
          maxLength = Math.max(maxLength, cellValue.length);
        });
      }
      
      // Aplicar ancho específico si está configurado para esta columna
      if (config.columnWidths[column.header]) {
        column.width = config.columnWidths[column.header];
      } else if (config.autoFitColumns) {
        // Aplicar límite máximo general
        column.width = Math.min(maxLength, config.maxColumnWidth);
      }
    });

    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.alignment = {
          wrapText: true,
          vertical: "top",
          horizontal: "left",
        };
      });
      // Ajustar altura de fila automáticamente para contenido con salto de línea
      row.height = undefined; // Permite que Excel calcule la altura automáticamente
    });

    try {
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer]), `${fileName}.xlsx`);
    } catch (error) {
      console.error("Error al escribir el archivo Excel:", error);
    }
  },

  translateDate(date) {
    if (!date) return "";
    const parsedDate = new Date(date);
    if (isNaN(parsedDate)) return date;

    const day = String(parsedDate.getUTCDate()).padStart(2, "0");
    const month = String(parsedDate.getUTCMonth() + 1).padStart(2, "0");
    const year = parsedDate.getUTCFullYear();

    return `${day}/${month}/${year}`;
  },

  async validarCabecerasExcel(file, expectedHeaders) {
    const workbook = new ExcelJS.Workbook();
    const buffer = await file.arrayBuffer();
    await workbook.xlsx.load(buffer);

    const sheet = workbook.getWorksheet(1); // Primera hoja
    const headers = sheet.getRow(1).values.slice(1); // Encabezados desde la fila 1

    const normalizedHeaders = headers.map(h => h?.toString().trim().toUpperCase());
    const normalizedExpected = expectedHeaders.map(h => h.toString().trim().toUpperCase());

    if (normalizedHeaders.length < normalizedExpected.length) {
      store.commit(
        "user/setAlertMessage",
        {
          type: "warning",
          message: "La cantidad de cabeceras es menor a la esperada",
        },
        { root: true }
      );
      return false;
    }

    if (!normalizedExpected.every(header =>
      normalizedHeaders.includes(header))) {
      store.commit(
        "user/setAlertMessage",
        {
          type: "warning",
          message:
            "Formato de cabeceras inválido, consulte el formato ejemplo.",
        },
        { root: true }
      );
      return false;
    }

    return true;
  },
};

export default helperExcel;
